import React, { useCallback, useEffect, useRef } from "react";

// ---------- Inline editierbarer Textblock ---------------------------------
export default function EditableText({ value, defaultText, onSave, multiline = true, className = "" }) {
  const ref = useRef(null);
  const tRef = useRef(null);
  const display = value && value.trim() ? value : defaultText;

  // Set initial content only once per mount; further updates via blur to avoid
  // cursor-jumping while user is typing.
  useEffect(() => {
    if (ref.current && ref.current.innerText !== display) {
      ref.current.innerText = display;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInput = useCallback(() => {
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(() => {
      const next = ref.current?.innerText || "";
      // Only save if the user actually changed it (differs from current value
      // AND from default-when-empty). This prevents "default text" being saved
      // verbatim and locking the placeholder.
      const isDefault = !value && next === defaultText;
      if (!isDefault && next !== (value || "")) {
        onSave(next);
      }
    }, 700);
  }, [value, defaultText, onSave]);

  const onKeyDown = (e) => {
    // Block Enter in single-line mode
    if (!multiline && e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <div
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      onInput={onInput}
      onKeyDown={onKeyDown}
      className={`outline-none focus:bg-yellow-50/40 focus:ring-1 focus:ring-cyan-300 rounded-sm transition-colors whitespace-pre-wrap ${className}`}
      data-placeholder={defaultText}
    />
  );
}
